import pdfUrls from "../infrastructures/urlConfig/StaticFooterPages/pdfUrl";
export const footerInvestor = {
    financials: [
        {
            title: "2023-24",
            data: [
                {
                    pdfName: "Form_MGT_7",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        pdfUrls.eblFinancial +
                        "/Form_MGT_7.pdf",
                },
                {
                    pdfName: "Financial Results - June 30, 2023",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        pdfUrls.eblFinancial +
                        "/FinancialResultsJune2023.pdf",
                },
            ],
        },
        {
            title: "2022-23",
            data: [
                {
                    pdfName: "Financial Results for June 30, 2022",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        pdfUrls.eblFinancial +
                        "/EBL_FinancialResultsJune2022.pdf",
                },
                {
                    pdfName: "Financial Results for September 30, 2022",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        pdfUrls.eblFinancial +
                        "/EBL_FinancialResultsSept2022.pdf",
                },
            ],
        },
        {
            title: "2021-22",
            data: [
                {
                    pdfName: "Financial Results - March 31, 2022",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        pdfUrls.eblFinancial +
                        "/EBL_21-22.pdf",
                },
                {
                    pdfName: "Un-audited Quarterly Financial Results - December 31, 2021",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        "/EBL_Annual_Reports/EBL_Quarterly_Report_FY_21-22.pdf",
                },
                {
                    pdfName: "Annual Report 2021-22 ",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        "/EBL_Annual_Reports/EBL_Annual_Report_FY_21-22.pdf",
                },
                {
                    pdfName: "Annual Return 2021-22 ",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        "/EBL_Annual_Reports/AnnualReturn21-22.pdf",
                },
            ],
        },
        {
            title: "2020-21",
            data: [
                {
                    pdfName: "Financial Results 2020-21",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        pdfUrls.eblFinancial +
                        "/EBL_20-21.pdf",
                },
                {
                    pdfName: "Annual Report 2020-21",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        "/EBL_Annual_Reports/EBL_Annual_Report_FY_20-21.pdf",
                },
            ],
        },
        {
            title: "2019-20",
            data: [
                {
                    pdfName: "Financial Results 2019-20",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        pdfUrls.eblFinancial +
                        "/EBL_19-20.pdf",
                },
                {
                    pdfName: "Annual Report 2019-20",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        "/EBL_Annual_Reports/EBL_Annual_Report_FY_19-20.pdf",
                },
            ],
        },
        {
            title: "2018-19",
            data: [
                {
                    pdfName: "Financial Results 2018-19",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        pdfUrls.eblFinancial +
                        "/EBL_18-19.pdf",
                },
                {
                    pdfName: "Annual Report 2018-19",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        "/EBL_Annual_Reports/EBL_Annual_Report_FY_18-19.pdf",
                },
            ],
        },
        {
            title: "2017-18",
            data: [
                {
                    pdfName: "Financial Results 2017-18",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        pdfUrls.eblFinancial +
                        "/EBL_17-18.pdf",
                },
                {
                    pdfName: "Annual Report 2017-18",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        "/EBL_Annual_Reports/EBL_Annual_Report_FY_17-18.pdf",
                },
            ],
        },
        {
            title: "2016-17",
            data: [
                {
                    pdfName: "Financial Results 2016-17",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        pdfUrls.eblFinancial +
                        "/EBL_16-17.pdf",
                },
                {
                    pdfName: "Annual Report 2016-17",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        "/EBL_Annual_Reports/EBL_Annual_Report_FY_16-17.pdf",
                },
            ],
        },
        {
            title: "2015-16",
            data: [
                {
                    pdfName: "Financial Results 2015-16",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        pdfUrls.eblFinancial +
                        "/EBL_15-16.pdf",
                },
            ],
        },
    ],
    valuation: {
        pdfName: "",
        link: pdfUrls.baseUrl +
            pdfUrls.ewweb +
            pdfUrls.webfile +
            pdfUrls.ebl +
            "/NWIL-CRISIL.pdf",
    },
    publicIssue: {
        pdfName: "",
        link: pdfUrls.baseUrl +
            pdfUrls.ewweb +
            pdfUrls.webfile +
            pdfUrls.ebl +
            "/PID/EBL29June2022.pdf",
    },
    boardcommittees: {
        pdfName: "Board Committees",
        link: pdfUrls.baseUrl +
            pdfUrls.ewweb +
            pdfUrls.webfile +
            pdfUrls.ebl +
            "/Board_Committees.pdf",
    },
    policyAndCode: [
        {
            pdfName: "CSR Policy",
            link: pdfUrls.baseUrl +
                pdfUrls.ewweb +
                pdfUrls.webfile +
                pdfUrls.ebl +
                "/CSR_Policy.pdf",
        },
        {
            pdfName: "Whistle Blower Policy",
            link: pdfUrls.baseUrl +
                pdfUrls.ewweb +
                pdfUrls.webfile +
                pdfUrls.ebl +
                "/Whistle_Blower_Policy.pdf",
        },
    ],
    announcements: [
        {
            title: "2023-24",
            data: [
                {
                    pdfName: "NWIL Reg 57(5) Confirmation",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        pdfUrls.announcement +
                        "/NWIL_Reg_57(5)_Confirmation.pdf",
                },
                {
                    pdfName: "NWIL CP Quarterly Statement for use of proceeds of funds",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        pdfUrls.announcement +
                        "/NWIL_CP_Quarterly_Statement_for_use_of_proceeds_of_funds.pdf",
                },
                {
                    pdfName: "Confirmation of payment of interest April 2023",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        pdfUrls.announcement +
                        "/Confirmation_of_payment_of_interest_April_2023.pdf",
                },
                {
                    pdfName: "NWIL Confirmation under Reg 40 & 61",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        pdfUrls.announcement +
                        "/NWIL_Confirmation.pdf",
                },
                {
                    pdfName: "Compliance Certificate - Reg 7(2)",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        pdfUrls.announcement +
                        "/ComplianceCertificate.pdf",
                },
                {
                    pdfName: "Record date intimation for interest payout on NCDs- June 2023",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        pdfUrls.announcement +
                        "/RecordDateIntimation_jun23.pdf",
                },
                {
                    pdfName: "NWIL CG Report as on March 31, 2023",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        pdfUrls.announcement +
                        "/NWIL_CG_Report_Mar31_2023.pdf",
                },
                {
                    pdfName: "Large Corp Annual Disclosure Mar'23",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        pdfUrls.announcement +
                        "/LargeCorpAnnualDisclosureMar23.pdf",
                },
                {
                    pdfName: "Appointment of Director",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        pdfUrls.announcement +
                        "/AppointmentOfDirector.pdf",
                },
                {
                    pdfName: "Confirmation of payment of interest May 2023",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        pdfUrls.announcement +
                        "/ConfirmationOfPayment_may23.pdf",
                },
                {
                    pdfName: "Record date intimation for interest payout on NCDs- July 2023",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        pdfUrls.announcement +
                        "/RecordDateIntimation_july23.pdf",
                },
                {
                    pdfName: "Appointment of Company Secretary",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        pdfUrls.announcement +
                        "/AppointmentOfCompanySecretary.pdf",
                },
                {
                    pdfName: "Confirmation of payment of interest June 2023",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        pdfUrls.announcement +
                        "/ConfirmationOfPayment_june23.pdf",
                },
                {
                    pdfName: "Record date intimation for Annual interest payout on NCDs- July 2023",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        pdfUrls.announcement +
                        "/RecordDateIntimationAnnual_july23.pdf",
                },
                {
                    pdfName: "Record date intimation for interest payout on NCDs- August 2023",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        pdfUrls.announcement +
                        "/ConfirmationOfPayment_Sept.pdf",
                },
                {
                    pdfName: "Confirmation of payment of interest July 2023",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        pdfUrls.announcement +
                        "/ConfirmationOfPayment_july23.pdf",
                },
                {
                    pdfName: "Clarification on payment date",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        pdfUrls.announcement +
                        "/PaymentDateClarification.pdf",
                },
                {
                    pdfName: "Confirmation of payment of Annual Interest - July 2023",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        pdfUrls.announcement +
                        "/ConfirmationOfPaymentAnnual_july23.pdf",
                },
                {
                    pdfName: "Record date intimation for interest payout on NCDs- September 2023",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        pdfUrls.announcement +
                        "/RecordDateIntimation_sept23.pdf",
                },
                {
                    pdfName: "Appointment of Mr. Kamlesh Vikamsey as an ID",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        pdfUrls.announcement +
                        "/AppointmentOfID.pdf",
                },
                {
                    pdfName: "Record date intimation for interest payout on NCDs- October 2023",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        pdfUrls.announcement +
                        "/RecordDateIntimation_oct23.pdf",
                },
                {
                    pdfName: "Confirmation of payment of interest Sept 2023",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        pdfUrls.announcement +
                        "/ConfirmationOfPayment_sept23.pdf",
                },
                {
                    pdfName: "Confirmation of payment of interest November 2022",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        pdfUrls.announcement +
                        "/ConfirmationOfPayment_nov.pdf",
                },
                {
                    pdfName: "Record date intimation for interest payout on NCDs- November 2023",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        pdfUrls.announcement +
                        "/RecordDateIntimation_nov23.pdf",
                },
                {
                    pdfName: "Proceedings of EGM of the Company - Sept 28, 2023",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        pdfUrls.announcement +
                        "/ProceedingsOfEGM.pdf",
                },
                {
                    pdfName: "Confirmation of payment of interest Oct 2023",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        pdfUrls.announcement +
                        "/ConfirmationOfPayment_oct23.pdf",
                },
                {
                    pdfName: "Prior Intimation for Board Meeting - Oct'23",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        pdfUrls.announcement +
                        "/BoardMeetingIntimationOct23.pdf",
                },
                {
                    pdfName: "Record date intimation for interest payout on NCDs- December 2023",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        pdfUrls.announcement +
                        "/RecordDateIntimation_dec23.pdf",
                },
            ],
        },
        {
            title: "2022-23",
            data: [
                {
                    pdfName: "NWIL Reg 57(5) Confirmation",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        pdfUrls.announcement +
                        "/EBLReg57Confirmation.pdf",
                },
                {
                    pdfName: "NWIL ISIN recon March 31, 2022",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        pdfUrls.announcement +
                        "/EBL_ISIN_ReconMarch31_2022.pdf",
                },
                {
                    pdfName: "NWIL CP Quarterly Statement for use of proceeds of funds",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        pdfUrls.announcement +
                        "/EBLCPQuarterlyStatementForUseOfProceedsOfFunds.pdf",
                },
                {
                    pdfName: "NWIL confirmation under 40 & 61",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        pdfUrls.announcement +
                        "/EBLconfirmationUnder40and61.pdf",
                },
                {
                    pdfName: "Reg 7 (2) March 31, 2022",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        pdfUrls.announcement +
                        "/EBLComplianceCertificate.pdf",
                },
                {
                    pdfName: "Outcome of BM",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        pdfUrls.announcement +
                        "/OutcomeOfBM.pdf",
                },
                {
                    pdfName: "NWIL - BSE intimation change in CS",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        pdfUrls.announcement +
                        "/EBL_BSEintimationChangeInCS.pdf",
                },
                {
                    pdfName: "NWIL CP Quarterly Statement for use of proceeds of funds",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        pdfUrls.announcement +
                        "/EBL_CP_QuarterlyStatement.pdf",
                },
                {
                    pdfName: "NWIL Reg 57(5) Confirmation",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        pdfUrls.announcement +
                        "/EBL_Reg57(5)Confirmation.pdf",
                },
                {
                    pdfName: "NWIL - Hawk - Early closure letter",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        pdfUrls.announcement +
                        "/EBL_HawkEarlyClosureLetter.pdf",
                },
                {
                    pdfName: "Revision in Credit Rating- August 5, 2022",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        pdfUrls.announcement +
                        "/Revision_in_Credit_Rating.pdf",
                },
                {
                    pdfName: "Record Date Intimation- September 2022",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        pdfUrls.announcement +
                        "/RecordDateIntimation.pdf",
                },
                {
                    pdfName: "Intimation for Resignation of CS",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        pdfUrls.announcement +
                        "/IntimationForResignationOfCS.pdf",
                },
                {
                    pdfName: "Record Date Intimation- October 2022",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        pdfUrls.announcement +
                        "/RecordDateIntimation_oct.pdf",
                },
                {
                    pdfName: "Confirmation of payment of interest September 2022",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        pdfUrls.announcement +
                        "/ConfirmationOfPayment_Sept.pdf",
                },
                {
                    pdfName: "EBL Record Date Intimation- November 2022",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        pdfUrls.announcement +
                        "/RecordDateIntimation_nov.pdf",
                },
                {
                    pdfName: "Confirmation of payment of interest October 2022",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        pdfUrls.announcement +
                        "/ConfirmationOfPayment_oct.pdf",
                },
                {
                    pdfName: "EBL-NWIL Name change announcement",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        pdfUrls.announcement +
                        "/NameChangeAnnouncement.pdf",
                },
                {
                    pdfName: "Revision in Credit Rating",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        pdfUrls.announcement +
                        "/CreditRatingRevision.pdf",
                },
                {
                    pdfName: "EBL Record Date Intimation- December 2022",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        pdfUrls.announcement +
                        "/RecordDateIntimation_dec.pdf",
                },
                {
                    pdfName: "Change in CS and NED",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        pdfUrls.announcement +
                        "/ChangeInCSandNED.pdf",
                },
                {
                    pdfName: "Revision in Credit Rating",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        pdfUrls.announcement +
                        "/RevisionInCreditRating.pdf",
                },
                {
                    pdfName: "Confirmation of payment of interest November 2022",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        pdfUrls.announcement +
                        "/ConfirmationOfPayment_nov.pdf",
                },
                {
                    pdfName: "EBL Record Date Intimation- January 2023",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        pdfUrls.announcement +
                        "/RecordDateIntimation_jan.pdf",
                },
                {
                    pdfName: "Approval for change in NED",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        pdfUrls.announcement +
                        "/ApprovalForNED.pdf",
                },
                {
                    pdfName: "Confirmation of payment of interest December 2022",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        pdfUrls.announcement +
                        "/ConfirmationOfPayment_dec.pdf",
                },
                {
                    pdfName: "NWIL Record Date Intimation- February 2023",
                    link: pdfUrls.baseUrl +
                        pdfUrls.ewweb +
                        pdfUrls.webfile +
                        pdfUrls.ebl +
                        pdfUrls.announcement +
                        "/RecordDateIntimation_feb.pdf",
                },
            ],
        },
    ],
    notices: [
        {
            pdfName: "AGM Notice July 21, 2022",
            link: pdfUrls.baseUrl +
                pdfUrls.ewweb +
                pdfUrls.webfile +
                pdfUrls.ebl +
                pdfUrls.notice +
                "/AGMnotice21July2022.pdf",
        },
        {
            pdfName: "BM Intimation July 21, 2022",
            link: pdfUrls.baseUrl +
                pdfUrls.ewweb +
                pdfUrls.webfile +
                pdfUrls.ebl +
                pdfUrls.notice +
                "/EBLIntimationForBMJuly22.pdf",
        },
        {
            pdfName: "BM Intimation Oct 20, 2022",
            link: pdfUrls.baseUrl +
                pdfUrls.ewweb +
                pdfUrls.webfile +
                pdfUrls.ebl +
                pdfUrls.notice +
                "/BMIntimationOct22.pdf",
        },
        {
            pdfName: "BM Intimation Oct 20 2022 - Revised",
            link: pdfUrls.baseUrl +
                pdfUrls.ewweb +
                pdfUrls.webfile +
                pdfUrls.ebl +
                pdfUrls.notice +
                "/BMIntimationOct22Revised.pdf",
        },
    ],
    noticeBoardCol1: [
        {
            pdfName: "SEBI & Depository Guidelines",
            download: "SEBI & Depository Guidelines",
            link: pdfUrls.baseUrl +
                pdfUrls.ewweb +
                pdfUrls.webfile +
                pdfUrls.disclaimer +
                "/Rights_And_Obligations_NEW-DP_agreement_replace.pdf",
        },
        {
            pdfName: "SEBI Guidelines",
            download: "SEBI Guidelines",
            link: pdfUrls.baseUrl +
                pdfUrls.ewweb +
                pdfUrls.webfile +
                pdfUrls.disclaimer +
                "/SEBIGuidelines.pdf",
        },
        {
            pdfName: "Exchange Holidays",
            download: "",
            link: "/important-messages/Exchange-Holidays",
        },
        {
            pdfName: "Exchange Charge Sheet",
            download: "",
            link: "/important-messages/Exchange-Charge-Sheet",
        },
        {
            pdfName: "SEBI Website",
            download: "",
            link: "http://www.sebi.gov.in/sebiweb/",
        },
        {
            pdfName: "Risk Policy NWIL -TM",
            download: "",
            link: pdfUrls.baseUrl +
                pdfUrls.ewweb +
                pdfUrls.webfile +
                pdfUrls.disclaimer +
                "/risk-policy-ebl-tm.pdf",
        },
        {
            pdfName: "Circular Updates",
            download: "",
            link: "/important-messages/circulars",
        },
        {
            pdfName: "Circulars and FAQs Increasing Awareness on Rights Entitlement",
            download: "Circulars and FAQs",
            link: pdfUrls.baseUrl +
                pdfUrls.ewweb +
                pdfUrls.webfile +
                pdfUrls.disclaimer +
                "/Circulars_and_FAQs_on_Increasing_Awareness_on_Rights_Entitlement.pdf",
        },
    ],
    noticeBoardCol2: [
        {
            pdfName: "NSDL - Demat Structure",
            download: "NSDL - Demat Structure",
            link: pdfUrls.baseUrl +
                pdfUrls.ewweb +
                pdfUrls.webfile +
                pdfUrls.disclaimer +
                "/NSDL_Demat_Structure.pdf",
        },
        {
            pdfName: "CDSL - Demat Structure",
            download: "CDSL - Demat Structure",
            link: pdfUrls.baseUrl +
                pdfUrls.ewweb +
                pdfUrls.webfile +
                pdfUrls.disclaimer +
                "/CDSL_Demat_Structure.pdf",
        },
        {
            pdfName: "MCX Website",
            download: "",
            link: "https://www.mcxindia.com/",
        },
        {
            pdfName: "NCDEX Website",
            download: "",
            link: "https://www.ncdex.com/index.aspx",
        },
        {
            pdfName: "Vernacular Languages",
            download: "",
            link: "/important-messages/vernacular-lang",
        },
        {
            pdfName: "Precautions for clients dealing in Options",
            download: "",
            link: "/important-messages/Precautions-for-clients",
        },
        {
            pdfName: "Advisory for Investors",
            download: "",
            link: "/important-messages/Advisory-for-investors",
        },
        {
            pdfName: "NWIL Permitted Client Bank Accounts",
            download: "NWIL Permitted Client Bank Accounts",
            link: pdfUrls.baseUrl +
                pdfUrls.ewweb +
                pdfUrls.webfile +
                pdfUrls.disclaimer +
                "/PermittedClientBankAccounts.pdf",
        },
    ],
    quickLinksCol1: [
        {
            pdfName: "KYC Form NWIL – Individual",
            download: "KYC Form NWIL – Individual",
            link: pdfUrls.baseUrl +
                pdfUrls.ewweb +
                pdfUrls.webfile +
                pdfUrls.disclaimer +
                "/KYC-Individual.pdf",
        },
        {
            pdfName: "KYC Form NWIL – Non Individual",
            download: "KYC Form NWIL – Non Individual",
            link: pdfUrls.baseUrl +
                pdfUrls.ewweb +
                pdfUrls.webfile +
                pdfUrls.disclaimer +
                "/KYC-NonIndividual.pdf",
        },
        {
            pdfName: "Mini NWIL Booklet ",
            download: "Mini NWIL Booklet",
            link: pdfUrls.baseUrl +
                pdfUrls.ewweb +
                pdfUrls.webfile +
                pdfUrls.disclaimer +
                "/MiniNWIL_Booklet.pdf",
        },
        {
            pdfName: "Combined DIS requisition form – CDSL/NSDL",
            download: "DIS requisition form NSDL",
            link: pdfUrls.baseUrl +
                pdfUrls.ewweb +
                pdfUrls.webfile +
                pdfUrls.disclaimer +
                "/combine_DIS_requisition.pdf",
        },
        {
            pdfName: "Filing complaints on Scores",
            download: "Benefits of Scores",
            link: pdfUrls.baseUrl +
                pdfUrls.ewweb +
                pdfUrls.webfile +
                pdfUrls.disclaimer +
                "/Benefits_of_scores.pdf",
        },
        {
            pdfName: "Voting Links",
            download: "Voting Links",
            link: pdfUrls.baseUrl +
                pdfUrls.ewweb +
                pdfUrls.webfile +
                pdfUrls.disclaimer +
                "/VotingLinks.pdf",
        },
        {
            pdfName: "Details of Authorised Persons",
            download: "Details of Authorised Persons",
            link: pdfUrls.baseUrl +
                pdfUrls.ewweb +
                pdfUrls.webfile +
                pdfUrls.disclaimer +
                "/authorisedPersonsDetails.csv",
        },
        {
            pdfName: "Account Opening Process",
            download: "Account Opening Process",
            link: pdfUrls.baseUrl +
                pdfUrls.ewweb +
                pdfUrls.webfile +
                pdfUrls.disclaimer +
                "/AOProcess.pdf",
        },
        {
            pdfName: "Investor Risk Reduction Access",
            download: "Investor Risk Reduction Access",
            link: pdfUrls.baseUrl +
                pdfUrls.ewweb +
                pdfUrls.webfile +
                pdfUrls.disclaimer +
                "/IRRA.pdf",
        },
    ],
    quickLinksCol2: [
        {
            pdfName: "Mutual Fund Segment Activation",
            download: "Mutual Fund Segment Activation",
            link: pdfUrls.baseUrl +
                pdfUrls.ewweb +
                pdfUrls.webfile +
                pdfUrls.disclaimer +
                "/MFSS-Docs.pdf",
        },
        {
            pdfName: "Segment activation form",
            download: "Segment activation form",
            link: pdfUrls.baseUrl +
                pdfUrls.ewweb +
                pdfUrls.webfile +
                pdfUrls.disclaimer +
                "/segment-activation.pdf",
        },
        {
            pdfName: "Account Modification Form",
            download: "Account Modification Form",
            link: pdfUrls.baseUrl +
                pdfUrls.ewweb +
                pdfUrls.webfile +
                pdfUrls.disclaimer +
                "/EBL_Trading_Account.pdf",
        },
        {
            pdfName: "Terms and conditions for SMTF",
            download: "SMTF T&amp;C",
            link: pdfUrls.baseUrl +
                pdfUrls.ewweb +
                pdfUrls.webfile +
                pdfUrls.disclaimer +
                "/SMTF_TC.pdf",
        },
        {
            pdfName: "SMTF Risk Policy",
            download: "Margin Trading Risk - Policy",
            link: pdfUrls.baseUrl +
                pdfUrls.ewweb +
                pdfUrls.webfile +
                pdfUrls.disclaimer +
                "/Margin_Trading_Risk_Policy.pdf",
        },
        {
            pdfName: "Risk Disclosure",
            download: "Risk Disclosure",
            link: pdfUrls.baseUrl +
                pdfUrls.ewweb +
                pdfUrls.webfile +
                pdfUrls.disclaimer +
                "/RiskDisclosure.pdf",
        },
        {
            pdfName: "Details of branches",
            download: "Details of branches",
            link: pdfUrls.baseUrl +
                pdfUrls.ewweb +
                pdfUrls.webfile +
                pdfUrls.disclaimer +
                "/BranchDetails.csv",
        },
        {
            pdfName: "Online Dispute Resolution Portal",
            download: "Online Dispute Resolution Portal",
            link: "https://smartodr.in/login",
        },
    ],
};
export const StaticFooter = '{"data":{"type":"newHolidayResponseDao","bse":[{"holiday_date":"2022-01-26","purpose":"Republic Day"},{"holiday_date":"2022-03-01","purpose":"Mahashivratri"},{"holiday_date":"2022-03-18","purpose":"Holi"},{"holiday_date":"2022-04-14","purpose":"Dr.Baba Saheb Ambedkar Jayanti"},{"holiday_date":"2022-04-15","purpose":"Good Friday"},{"holiday_date":"2022-05-03","purpose":"Id-Ul-Fitr (Ramzan Id)"},{"holiday_date":"2022-08-09","purpose":"Muharram"},{"holiday_date":"2022-08-15","purpose":"Independence Day"},{"holiday_date":"2022-08-31","purpose":"Ganesh Chaturthi"},{"holiday_date":"2022-10-05","purpose":"Dussehra"},{"holiday_date":"2022-10-24","purpose":"Diwali Laxmi Pujan"},{"holiday_date":"2022-10-26","purpose":"Diwali Balipratipada"},{"holiday_date":"2022-11-08","purpose":"Gurunanak Jayanti"}],"nse":[{"holiday_date":"2022-01-26","purpose":"Republic Day"},{"holiday_date":"2022-03-01","purpose":"Mahashivratri"},{"holiday_date":"2022-03-18","purpose":"Holi"},{"holiday_date":"2022-04-14","purpose":"Dr.Baba Saheb Ambedkar Jayanti"},{"holiday_date":"2022-04-15","purpose":"Good Friday"},{"holiday_date":"2022-05-03","purpose":"Id-Ul-Fitr (Ramzan Id)"},{"holiday_date":"2022-08-09","purpose":"Muharram"},{"holiday_date":"2022-08-15","purpose":"Independence Day"},{"holiday_date":"2022-08-31","purpose":"Ganesh Chaturthi"},{"holiday_date":"2022-10-05","purpose":"Dussehra"},{"holiday_date":"2022-10-24","purpose":"Diwali Laxmi Pujan"},{"holiday_date":"2022-10-26","purpose":"Diwali Balipratipada"},{"holiday_date":"2022-11-08","purpose":"Gurunanak Jayanti"}]}}';
